export const INVOICE_STATUS = {
  DRAFT: 'Draft',
  REVIEW_REQUIRED: 'review_required',
  NOT_REQUIRED: 'not_required',
  INVOICED: 'Invoiced'
}

export const INVOICE_STATUS_OPTIONS = [
  { text: 'Draft', value: INVOICE_STATUS.DRAFT },
  { text: 'Review Required', value: INVOICE_STATUS.REVIEW_REQUIRED },
  { text: 'Not Required', value: INVOICE_STATUS.NOT_REQUIRED },
  { text: 'Invoiced', value: INVOICE_STATUS.INVOICED }
]

export const INVOICE_STATUS_LABELS = {
  [INVOICE_STATUS.DRAFT]: 'Draft',
  [INVOICE_STATUS.REVIEW_REQUIRED]: 'Review Required',
  [INVOICE_STATUS.NOT_REQUIRED]: 'Not Required',
  [INVOICE_STATUS.INVOICED]: 'Invoiced'
}

export const INVOICE_STATUS_COLORS = {
  [INVOICE_STATUS.DRAFT]: 'grey',
  [INVOICE_STATUS.REVIEW_REQUIRED]: 'orange',
  [INVOICE_STATUS.NOT_REQUIRED]: 'blue-grey',
  [INVOICE_STATUS.INVOICED]: 'green'
}

export function getInvoiceStatusLabel(status) {
  return INVOICE_STATUS_LABELS[status] || status
}

export function getInvoiceStatusColor(status) {
  return INVOICE_STATUS_COLORS[status] || 'grey'
}

export function isInvoicedStatus(status) {
  return status === INVOICE_STATUS.INVOICED
}
